module.exports = {
          srcSet: __webpack_public_path__ + "public/36354a2ef2f892a4840822abe71ad988-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/36354a2ef2f892a4840822abe71ad988-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/36354a2ef2f892a4840822abe71ad988-80.png",
          toString:function(){return __webpack_public_path__ + "public/36354a2ef2f892a4840822abe71ad988-80.png"},
          
          width: 80,
          height: 80
        }